"use client";
const CONSENT_KEY = "dobbix_analytics_consent";
function getStorage() {
    if (typeof window === "undefined")
        return null;
    try {
        return window.localStorage;
    }
    catch {
        return null;
    }
}
/** Read the persisted consent value. Returns "unknown" when not yet set. */
export function getConsent() {
    const storage = getStorage();
    if (!storage)
        return "unknown";
    try {
        const value = storage.getItem(CONSENT_KEY);
        if (value === "granted" || value === "denied")
            return value;
        return "unknown";
    }
    catch {
        return "unknown";
    }
}
/** Persist the user's consent choice. */
export function setConsent(status) {
    const storage = getStorage();
    if (!storage)
        return;
    try {
        storage.setItem(CONSENT_KEY, status);
    }
    catch {
        // Storage full or blocked — silently ignore.
    }
}
/** Returns true when analytics events should fire. */
export function hasConsent() {
    return getConsent() === "granted";
}
